import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    paddingBottom: 24,
    gap: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  body: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  title: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  text: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
  button: {
    backgroundColor: neutrals.white,
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      color: brand.main.variations['lighterWater-2'],
    }),
  },
  leftTextTitleMobile: {
    ...textLatoStyleDS.TitleBoldXl,
    color: ColorTypography.TextColorPromo,
  },
  leftElement: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftTextContainer: {
    gap: 8,
    flex: 1,
  },
  leftTextSubTitleMobile: {
    ...textLatoStyleDS.BodyBoldMd,
    color: '#302030',
  },
});
